export const EMAIL_SERVICE_ID = process.env.REACT_APP_EMAIL_SERVICE_ID;
export const EMAIL_TEMPLATE_ID = "template_g57nqz4";
export const EMAILJS_ID = process.env.REACT_APP_EMAILJS_ID;
export const EMAILJS_TOKEN = process.env.REACT_APP_EMAILJS_TOKEN;
export const REPLY_TO_EMAIL = "management@nickdorian.com";
